export const AGREEXA_APP_URL = 'https://agreexagit.lovable.app/'
